import React, { useCallback, useEffect } from 'react'
import { useLocation } from 'react-router'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'store'
import { useTranslation } from 'react-i18next'

import Icon from '@mdi/react'
import { mdiArrowCollapseRight, mdiArrowCollapseLeft, mdiArrowCollapseUp } from '@mdi/js'

import Button from 'devextreme-react/button'
import Tooltip from 'devextreme-react/tooltip'

import { PanelState, setTabsPanelState, setActiveTabIndex, setTabs } from 'slices/ui'
import { RootState } from 'slices'

import './tabs-panel.scss'


export const TabsPanel = () => {
    const location = useLocation()
    const dispatch = useAppDispatch()
    const { tabsPanelState, tabs, activeTabIndex, actionPanelState, drawerState, tabsVisible  } = useSelector((state: RootState) => state.ui)
    const { t } = useTranslation()

    const onClick = useCallback((i: number) => (() => { dispatch(setActiveTabIndex(i)) }), [dispatch])

    const setStateCallback = useCallback((state: PanelState) => {
        return () => { dispatch(setTabsPanelState(state)) }
    }, [dispatch])

    const getPanelStateClass = useCallback((state: PanelState) => `tabs-panel--${state}`, [])

    useEffect(() => {
        dispatch(setTabs([]))
    }, [dispatch, location.pathname])

    if (!tabsVisible) { return null }

    return (
        <div
            className={`tabs-panel ${getPanelStateClass(tabsPanelState)}`}
            style={(tabsPanelState !== 'top' && { top: actionPanelState === 'top' ? '45px' : '5px' }) || {}}
        >
            <div className='tabs-panel--before' style={{marginLeft: drawerState === 2 ? '40px' : ''}}>
                {
                    tabsPanelState !== 'top'
                        ? (
                            <div id='tabsPanelToggleBtnTop'>
                                <Button
                                    className='tabs-panel--collapse-btn'
                                    icon={tabsPanelState === 'right' ? 'chevrondoubleleft' : 'chevrondoubleright'}
                                    onClick={setStateCallback('top')}
                                    style={tabsPanelState !== 'right' ? { marginLeft: '.1rem' } : { marginRight: '.1rem' }}
                                >
                                    <Icon path={mdiArrowCollapseUp} size='16px' style={{ margin: 1 }} />
                                </Button>
                                <Tooltip target='#tabsPanelToggleBtnTop' position='bottom' showEvent={{ name: 'dxhoverstart', delay: 200 }} hideEvent='dxhoverend'>
                                    <div>{t('global:action.expand')}</div>
                                </Tooltip>
                            </div>
                        )
                        : null
                }

                {
                    tabs.map((tab, i) => (
                        (tab.visible || tab.visible === undefined) && <div id={`tab${i}`} key={`tab${i}`} className={`tabs-panel--item ${activeTabIndex === i ? 'active' : ''}`}>
                            <Button
                                icon={tab.icon}
                                onClick={onClick(i)}
                                disabled={tab.disabled}
                                style={{
                                    marginRight:`${i === 0 && '15px'}`,
                                    marginBottom: `${i === 0 && tabsPanelState !== 'top' ? '10px' : '0'}`
                                }}
                            />
                            <Tooltip target={`#tab${i}`} position='bottom' showEvent={{ name: 'dxhoverstart', delay: 200 }} hideEvent='dxhoverend'>
                                <div>{tab.userfriendlyName ||  tab.name}</div>
                            </Tooltip>
                        </div>
                    ))
                }
            </div>

            <div className='tabs-panel--after'>
                {
                    tabsPanelState === 'top'
                        ? (
                            <>
                                <div id='tabsPanelToggleBtnLeft'>
                                    <Button className='tabs-panel--collapse-btn' icon='chevrondoubleleft' onClick={setStateCallback('left')}>
                                        <Icon path={mdiArrowCollapseLeft} size='16px' style={{ margin: '1px' }} />
                                    </Button>
                                    <Tooltip target='#tabsPanelToggleBtnLeft' position='bottom' showEvent={{ name: 'dxhoverstart', delay: 200 }} hideEvent='dxhoverend'>
                                        <div>{t('global:action.collapse')}</div>
                                    </Tooltip>
                                </div>
                                <div id='tabsPanelToggleBtnRight'>
                                    <Button className='tabs-panel--collapse-btn' icon='chevrondoubleright' onClick={setStateCallback('right')}>
                                        <Icon path={mdiArrowCollapseRight} size='16px' style={{ margin: 1 }} />
                                    </Button>
                                    <Tooltip target='#tabsPanelToggleBtnRight' position='bottom' showEvent={{ name: 'dxhoverstart', delay: 200 }} hideEvent='dxhoverend'>
                                        <div>{t('global:action.collapse')}</div>
                                    </Tooltip>
                                </div>
                            </>
                        )
                        : null
                }

            </div>
        </div>
    )
}
